import type { IconData } from '@stacksjs/iconify-core'

export const compassNavigatorFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M46.745 6.383a4.364 4.364 0 0 0-5.13-5.11c-4.052.774-10.499 2.104-16.464 3.766c-2.981.83-5.872 1.751-8.297 2.738c-2.371.965-4.487 2.066-5.749 3.327s-2.362 3.378-3.327 5.75c-.986 2.424-1.908 5.315-2.738 8.296c-1.662 5.966-2.993 12.412-3.768 16.465a4.364 4.364 0 0 0 5.111 5.13c4.04-.756 10.457-2.061 16.413-3.717c2.975-.828 5.866-1.751 8.3-2.748c2.385-.978 4.512-2.096 5.8-3.385s2.407-3.415 3.384-5.8c.997-2.433 1.92-5.324 2.748-8.3c1.656-5.955 2.96-12.372 3.717-16.412\"/><path fill=\"#2859c5\" d=\"M31.5 24a7.5 7.5 0 1 1-15 0a7.5 7.5 0 0 1 15 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default compassNavigatorFlat
